import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import moment from 'moment/moment';

import { getSizeString } from '../../../components/timeline-chart/utils';
import type { Viewport } from '../../../shared/viewport/viewport';
import { calculateItemOffsetParams } from '../../../shared/viewport/viewport-calculator';

import styles from './header.module.scss';

interface Props {
  viewport: Viewport;
  isCompactView: boolean;
}

export const CurrentDate = observer(function CurrentDate({ viewport, isCompactView }: Props) {
  const currentDate = moment().unix();

  if (currentDate < viewport.start || currentDate > viewport.end) {
    return null;
  }

  const { offset } = calculateItemOffsetParams(viewport, { start: currentDate, end: currentDate + 1 });

  return (
    <div
      className={clsx(styles.currentDateWrapper, !isCompactView && styles.currentDateWrapper_months)}
      style={{ marginLeft: getSizeString(offset) }}
    >
      <p className={styles.currentDateLabel}>{moment().format('DD.MM.YYYY')}</p>
    </div>
  );
});
